import { render, staticRenderFns } from "./ZhihuPage.vue?vue&type=template&id=4d8c2eaa&scoped=true"
import script from "./ZhihuPage.vue?vue&type=script&lang=js"
export * from "./ZhihuPage.vue?vue&type=script&lang=js"
import style0 from "./ZhihuPage.vue?vue&type=style&index=0&id=4d8c2eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8c2eaa",
  null
  
)

export default component.exports